import dayjs from 'dayjs'
import { localStorageGetItem } from './storage'

type fDateOptions = {
  [key: string]: {
    [key: string]: string
  }
}

export const fDate = (date: string, option: string = 'default') => {
  const locale = localStorageGetItem('i18nextLng', 'en-GB')

  const options: fDateOptions = {
    default: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
    short: {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    },
    dateTime: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    },
  }

  return new Date(date)
    .toLocaleString(locale, options[option])
    .replace(/ de /g, ' ')
    .replace('.', '')
}

export const getDateFormatByLocale = (locale: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }

  const formatter = new Intl.DateTimeFormat(locale, options)
  const parts = formatter.formatToParts(new Date())

  const dateFormat = parts
    .map((part) => {
      if (part.type === 'literal') {
        return part.value
      } else if (part.type === 'day') {
        return 'DD'
      } else if (part.type === 'month') {
        return 'MM'
      } else if (part.type === 'year') {
        return 'YYYY'
      }
      return ''
    })
    .join('')

  return dateFormat
}

export const formatDateWithoutSymbols = (date: string) => {
  const newDate = new Date(date)
  const year = newDate.getFullYear()
  const month = String(newDate.getMonth() + 1).padStart(2, '0')
  const day = String(newDate.getDate()).padStart(2, '0')
  return `${year}${month}${day}`
}

export const formatDateWithoutTimezone = (
  date: string,
  option: string = 'default'
) => {
  const locale = localStorageGetItem('i18nextLng', 'en-GB')

  const options: fDateOptions = {
    default: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
    short: {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    },
    dateTime: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    },
  }

  const localDate = dayjs(date, 'YYYY-MM-DD').toDate()
  return localDate
    .toLocaleString(locale, options[option])
    .replace(/ de /g, ' ')
    .replace('.', '')
}
